const initialState = {
  total:     0,
  manual:    [],
  automatic: [],
  // Ce que le CLIENT a répondu : sa question, son refus (ProjectActivity::BELL_TYPES
  // côté serveur). Le reste de cet état ne parle que de silences — « rien ne bouge
  // depuis X jours ». Ces deux-là sont des faits, et quelqu'un attend un geste.
  clientEvents: [],
  catalogPriceUpdates: { items: [], drifted: [], discontinued: [] },
};

// items + drifted + discontinued comptent tous pour le badge — un coût
// personnalisé qui a dérivé ou une source retirée méritent l'attention de
// l'utilisateur autant qu'une synchro automatique.
const catalogCount = (cpu) => (cpu.items?.length || 0) + (cpu.drifted?.length || 0) + (cpu.discontinued?.length || 0);

// ⚠️ UN SEUL endroit qui compte la pastille. Elle se recalcule à chaque retrait local
// (terminer un rappel, acquitter un événement, fermer l'avis du catalogue) : quatre
// additions écrites à la main avaient déjà laissé passer une liste non comptée.
const recount = (s) => s.manual.length + s.automatic.length + s.clientEvents.length + catalogCount(s.catalogPriceUpdates);

const Reminders = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REMINDERS':
      return {
        ...state,
        total:     action.payload.total     ?? state.total,
        manual:    action.payload.manual    ?? state.manual,
        automatic: action.payload.automatic ?? state.automatic,
        clientEvents: action.payload.clientEvents ?? state.clientEvents,
        catalogPriceUpdates: action.payload.catalogPriceUpdates ?? state.catalogPriceUpdates,
      };
    case 'DISMISS_REMINDER': {
      const next = { ...state, manual: state.manual.filter((r) => r.id !== action.id) };
      return { ...next, total: recount(next) };
    }
    // Acquitter un événement client. Le même geste existe dans « Mes priorités » et dans
    // l'onglet Activité du projet ; les TROIS écrivent la même colonne `acknowledged_at`,
    // et les trois passent par `syncBellAcknowledgement` (actions/reminders) pour retirer
    // la rangée d'ici. C'est ce qui autorise à montrer la chose à trois endroits sans la
    // faire faire trois fois. ⚠️ Un quatrième appelant qui écrirait la colonne sans passer
    // par là laisserait la cloche mentir jusqu'au prochain chargement de la page.
    case 'ACKNOWLEDGE_CLIENT_EVENT': {
      const next = { ...state, clientEvents: state.clientEvents.filter((e) => e.id !== action.id) };
      return { ...next, total: recount(next) };
    }
    case 'DISMISS_CATALOG_PRICE_UPDATES': {
      const next = { ...state, catalogPriceUpdates: { ...state.catalogPriceUpdates, items: [] } };
      return { ...next, total: recount(next) };
    }
    default:
      return state;
  }
};

export default Reminders;
